import React from 'react'

import { useNavigate } from 'react-router-dom'

import { Section } from '../../_components'
import { theme } from '../../constants'

import { Page, EmptyState, ErrorState } from './styles'

export const SAMPLE_COURSES = [
  {
    id: 'sample-1',
    title: 'Curso sample: Respiración y apoyo',
    teacher: 'Equipo Diga Ah',
    image: '/assets/sing-women.png',
    progress: 0,
    lessons: 'Duración por confirmar',
    level: 'Nuevo',
  },
  {
    id: 'sample-2',
    title: 'Curso sample: Afinación guiada',
    teacher: 'Equipo Diga Ah',
    image: '/assets/microphone-man.png',
    progress: 35,
    lessons: '3 de 8 semanas',
    level: 'En progreso',
  },
] as const

interface LearningPathPageProps {
  courses?: readonly {
    id: string
    title: string
    teacher: string
    image: string
    progress: number
    lessons: string
    level: string
  }[]
  loading?: boolean
  error?: string | null
  sample?: boolean
}

const LearningPathPage = ({
  courses = [],
  loading = false,
  error = null,
  sample = false,
}: LearningPathPageProps) => {
  const navigate = useNavigate()

  const resolvedCourses = courses.length > 0 ? courses : SAMPLE_COURSES
  const showSampleNotice = sample && resolvedCourses.length > 0
  const sectionProps =
    resolvedCourses.length > 0
      ? {
          actionLabel: 'Ver curso',
          onAction: () => navigate('/ruta-formacion'),
        }
      : {}

  return (
    <Page>
      <Section
        title="Ruta de formación"
        subtitle="Tu camino de aprendizaje y los cursos asignados."
        {...sectionProps}
      >
        {error && (
          <ErrorState>
            <strong>No se pudo cargar la ruta de formación</strong>
            <p>{error}</p>
          </ErrorState>
        )}

        {!error && !loading && resolvedCourses.length === 0 && (
          <EmptyState>
            <strong>Todavía no tenés cursos asignados</strong>
            <p>
              Cuando el equipo asigne un curso, vas a verlo acá junto con tu
              progreso y las lecciones disponibles.
            </p>
          </EmptyState>
        )}

        {!error && resolvedCourses.length > 0 && (
          <div>
            {showSampleNotice && (
              <EmptyState>
                <strong>Vista previa del rediseño</strong>
                <p>
                  Estás viendo cursos de ejemplo. Cuando se defina la carga real
                  desde administración, esta vista se conectará a tus cursos
                  asignados.
                </p>
              </EmptyState>
            )}
            <div style={{ display: 'grid', gap: '1.25rem' }}>
              {resolvedCourses.map((course) => (
                <div
                  key={course.id}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'minmax(0, 1fr)',
                    gap: '0.75rem',
                    padding: '1.25rem',
                    border: theme.semanticColors.border.default,
                    borderRadius: theme.radii.large,
                    background: theme.semanticColors.background.surface,
                    cursor: 'pointer',
                  }}
                  onClick={() => navigate('/ruta-formacion')}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault()
                      navigate('/ruta-formacion')
                    }
                  }}
                  tabIndex={0}
                  role="link"
                >
                  <div style={{ display: 'grid', gap: '0.5rem' }}>
                    <strong style={{ fontSize: '1.1rem' }}>
                      {course.title}
                    </strong>
                    <span
                      style={{ color: theme.semanticColors.text.secondary }}
                    >
                      {course.teacher}
                    </span>
                    <span
                      style={{ color: theme.semanticColors.text.secondary }}
                    >
                      {course.lessons}
                    </span>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.75rem',
                    }}
                  >
                    <div
                      style={{
                        width: '100%',
                        height: '8px',
                        borderRadius: '999px',
                        background: theme.semanticColors.background.canvas,
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        style={{
                          width: `${Math.min(100, Math.max(0, course.progress))}%`,
                          height: '100%',
                          borderRadius: '999px',
                          background: theme.roleColors.student.main,
                        }}
                      />
                    </div>
                    <span
                      style={{
                        fontSize: '0.85rem',
                        color: theme.semanticColors.text.secondary,
                      }}
                    >
                      {course.level}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {loading && <EmptyState>Cargando cursos…</EmptyState>}
      </Section>
    </Page>
  )
}

export default LearningPathPage
